import React, { useRef } from "react";
// seo
import Helmet from "react-helmet";
// import { helmetJsonLdProp } from "react-schemaorg";

import Section from "../../components/shared-ui/Section/Section";
import Accordion from "../../components/shared-ui/Accordion/Accordion";
import PEDLayout from "./PEDLayout";
import PEDHeroHeader from "../../components/HeroHeader/PEDHeroHeader";

import "../../css/PED/FinancialAssistance.scss";

function showTermsModal(event) {
  let modal = document.getElementById("terms-modal");
  document.body.classList.add("no-scroll");
  modal.classList.remove("fadeOut");
  modal.style.display = "block";
  modal.classList.add("fadeIn");
  modal.style.height = "100vh";
  if (event.currentTarget.classList.contains("scroll-to-terms")) {
    const terms = document.getElementById("terms");
    const container = document.querySelector("#terms-modal .modal-container");
    container.scroll(0, terms.offsetTop);
  }
}

export default function FinancialAssistanceInformation() {
  const termsRef = useRef(null);
  const scrollToTerms = (e) => {
    e.preventDefault();
    termsRef.current.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <React.Fragment>
      <Helmet>
        <title>Information on accessing Doptelet for Caregivers | DOPTELET® and DOPTELET Sprinkle (avatrombopag)</title>
        <meta name="description" content="Find helpful treatment for your child's persistent or chronic ITP. Explore other access information and copay assistance for access." />
      </Helmet>
      <PEDLayout pageClass="ped-financial-assistance-information">
        <PEDHeroHeader
          extraClass="large-hero inner-bg home-hero"
          markup={
            <>
              <h1>Financial assistance information</h1>
              <p>
                Explore the financial and patient assistance options available
                through Doptelet Connect that can help your child access
                Doptelet or Doptelet Sprinkle.
              </p>
            </>
          }
          maxWidth="525"
          bgImage={[
            "/images/ped/hero/financial-hero-desktop.jpg",
            "/images/ped/hero/financial-hero-desktop.jpg",
          ]}
          bgImageMobile={[
            "/images/ped/hero/financial-hero.png",
            "/images/ped/hero/financial-hero@2x.png",
          ]}
        />

        <Section sectionClass="section-padding">
          <div className="pay-as-little">
            <div className="">
              <img src="/images/ped/financial/pay-as-little@2x.png" alt="" />
            </div>
            <div className="">
              <h2>Enroll in the Doptelet Copay Assistance Program</h2>
              <p>
                The Doptelet Copay Assistance Program is for eligible people who
                have commercial prescription insurance. If your child qualifies,
                you’ll be able to pay as little as $0 per prescription, and may
                receive up to a maximum benefit of $15,000 per calendar year.{" "}
                <a onClick={showTermsModal} href="#terms">
                  Terms and conditions apply
                </a>
                .
              </p>
              <a
                className="btn btn-primary btn-external-link btn-white"
                href="https://sobipatientsupport.iassist.com/patient/doptelet/copay-assist"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Enroll Now</span>
              </a>
            </div>
          </div>

          <div className="free-trial">
            <div className="">
              <img src="/images/ped/financial/free-trial@2x.png" alt="" />
            </div>
            <div className="">
              <h2>Try the Doptelet Free Trial Offer</h2>
              <p>
                The Free Trial Offer provides a 15-day supply of Doptelet or
                Doptelet Sprinkle, at no cost, to patients who are new to
                treatment and have persistent or chronic ITP. The Free Trial
                Offer allows physicians and patients to evaluate a patient’s
                clinical response to Doptelet or Doptelet Sprinkle to determine
                whether it is the appropriate treatment. If you are curious if
                Doptelet or Doptelet Sprinkle will work for your child, discuss
                the Doptelet Free Trial Offer with your child’s healthcare
                provider. You can find the form to request the Free Trial Offer
                (to be filled out by your child’s doctor) below. Your child’s
                provider may also request the Free Trial Offer online at
                DopteletConnectHCP.com.{" "}
                <a
                  style={{ margin: "0" }}
                  onClick={scrollToTerms}
                  href="/pediatric-itp/support-and-resources/caregiver-financial-assistance/#terms"
                >
                  Terms and conditions apply
                </a>
                .
              </p>
              <a
                className="btn btn-primary btn-white download download-white"
                href="/pdf/NP-38758_Doptelet_Free_Trial_Offer_Program_Request_Form_Digital_FINAL_2.11.25.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Download Form</span>
              </a>
              {/* <a
                className="btn btn-primary btn-white download download-white"
                href="/ped/"
              >
                <span>Download Form</span>
              </a> */}
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding doptelet-connect">
          <div className="doptelet-connect-header">
            <div className="">
              <img src="/images/ped/financial/doptelet-connect@2x.png" alt="" />
            </div>
            <div className="">
              <h2>
                After your child’s doctor prescribes Doptelet or Doptelet
                Sprinkle, Doptelet Connect can provide patient assistance
                options that may help them access treatment
              </h2>
              <h3>There are 3 ways to get support from Doptelet Connect:</h3>
            </div>
          </div>
          <div className="doptelet-connect-cards">
            <div className="doptelet-connect-card">
              <h3>Doptelet Connect Secure Online Portal</h3>
              <p>
                Go online to complete the Patient Consent form and provide the
                necessary information. From there, you can access the Portal to
                check your eligibility for Doptelet Copay assistance or upload
                information requested by Doptelet Connect.
              </p>
              <a
                href="https://sobipatientsupport.iassist.com/patient/doptelet/"
                className="btn btn-white btn-primary btn-external-link"
                target="_blank"
                rel="noreferrer noopener"
              >
                <span>Enroll</span>
              </a>
            </div>
            <div className="doptelet-connect-card">
              <h3>Prescription and Enrollment Form</h3>
              <p>
                To enroll in Doptelet Connect, your doctor will need to complete
                the form, including all healthcare provider and patient
                signatures, and fax to{" "}
                <a style={{ color: "#DA1A32" }} href="tel:18556868729">
                  1-855-686-8729
                </a>
                .
              </p>
              <a
                href="/pdf/NP-38058_V3.0_Doptelet_HUB_PST_US_Prescription_and_Enrollment_Form_Digital_FINAL_12.10.25.pdf"
                className="btn btn-white btn-primary download download-white"
                target="_blank"
                rel="noreferrer noopener"
              >
                <span style={{ minHeight: "30px" }}>Download</span>
              </a>
            </div>
            <div className="doptelet-connect-card">
              <h3>Call Doptelet Connect</h3>
              <p>
                To ask questions and get direct assistance, call{" "}
                <a style={{ color: "#DA1A32" }} href="tel:18333682663">
                  1-833-368-2663
                </a>
                .
              </p>
              <a
                href="tel:18333682663"
                className="btn btn-white btn-primary btn-external-link"
              >
                <span>Call</span>
              </a>
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding case-manager">
          <div className="case-manager-content">
            <div className="case-manager-content-image">
              <img src="/images/ped/financial/case-manager@2x.png" alt="" />
            </div>
            <div className="">
              <h2>Connect with Case Managers</h2>
              <h3>Here’s how it works:</h3>
              <div className="case-manager-content-cards">
                <div className="case-manager-content-card card1">
                  <div>
                    <img src="/images/ped/financial/icon1@2x.png" alt="" />
                  </div>
                  <div>
                    <h4>
                      First, your child’s doctor’s office will send their
                      prescription to Doptelet Connect for review.
                    </h4>
                  </div>
                </div>
                <div className="case-manager-content-card card2">
                  <div>
                    <img src="/images/ped/financial/icon2@2x.png" alt="" />
                  </div>
                  <div>
                    <h4>Next, dedicated Case Managers will help:</h4>
                    <ul>
                      <li>
                        <strong>Research</strong> your insurance plan
                      </li>
                      <li>
                        <strong>Determine</strong> a specialty pharmacy that can
                        fill and deliver your child’s Doptelet or Doptelet
                        Sprinkle prescription
                      </li>
                      <li>
                        <strong>Identify</strong> potential financial assistance
                        options that may be available
                      </li>
                    </ul>
                    <p>
                      <strong>
                        For more information, call{" "}
                        <a style={{ color: "#DA1A32" }} href="tel:18333682663">
                          1-833-368-2663
                        </a>
                        . Case Managers are available Monday–Friday 8:30 AM–7 PM
                        ET.
                      </strong>
                    </p>
                  </div>
                </div>
                <div className="case-manager-content-card card3">
                  <div>
                    <img src="/images/ped/financial/icon3@2x.png" alt="" />
                  </div>
                  <div>
                    <h4>
                      Finally, a pharmacy will contact you to confirm your
                      delivery details before sending you Doptelet or Doptelet
                      Sprinkle. It is important to answer or return calls from
                      the specialty pharmacy right away.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding connect-resources">
          <h2>Doptelet Connect resources</h2>
          <div className="connect-resources-cards">
            <div className="connect-resources-card">
              <div className="connect-resources-card-header">
                <img src="/images/ped/icons/icon-resources@2x.png" alt="" />
                <h3>Prescription and Enrollment Form</h3>
              </div>
              <p>
                To enroll in Doptelet Connect, work with your child’s healthcare
                provider to complete and sign this form.
              </p>
              <a
                href="/pdf/NP-38058_V3.0_Doptelet_HUB_PST_US_Prescription_and_Enrollment_Form_Digital_FINAL_12.10.25.pdf"
                className="btn btn-primary download w-100"
                target="_blank"
                rel="noreferrer noopener"
              >
                <span>Download Form</span>
              </a>
            </div>
            <div className="connect-resources-card">
              <div className="connect-resources-card-header">
                <img src="/images/ped/icons/icon-resources@2x.png" alt="" />
                <h3>Patient/Caregiver Consent Form</h3>
              </div>
              <p>
                Complete this form if your signature is requested by Doptelet
                Connect.
              </p>
              <a
                href="/pdf/patient-caregiver-enrollment-consent-form.pdf "
                className="btn btn-primary download w-100"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Download Form</span>
              </a>
              <a
                href="/pdf/NP-28713_Doptelet_Spanish_Consent_Form_Digital_FINAL_7.11.23.pdf"
                className="btn btn-primary download w-100"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>DESCARGAR EN español</span>
              </a>
            </div>
            <div className="connect-resources-card">
              <div className="connect-resources-card-header">
                <img src="/images/ped/icons/icon-resources@2x.png" alt="" />
                <h3>Patient Assistance Program Application</h3>
              </div>
              <p>
                To be evaluated for the Patient Assistance Program, work with
                your child’s healthcare provider to complete and sign this
                application.
              </p>
              <a
                href="/pdf/PP-16520_Doptelet_Patient_Assistance_Program_Application_Digital_FINAL_6.22.23.pdf"
                className="btn btn-primary download w-100"
                target="_blank"
                rel="noopener noreferrer"
              >
                <span>Download Form</span>
              </a>
            </div>
          </div>
        </Section>

        <Section sectionClass="section-padding discover-doptelet">
          <div className="discover-doptelet-header">
            <div className="discover-doptelet-header-content">
              <h2>Discover the Doptelet Copay Assistance Program</h2>
              <h3>
                Eligible commercially insured patients may qualify for the
                Doptelet Copay Assistance Program
              </h3>
            </div>
            <div className="discover-doptelet-header-image">
              <img src="/images/ped/financial/discover@2x.png" alt="" />
            </div>
          </div>
          <Accordion
            title="What’s the program?"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <ul>
                  <li>
                    Eligible patients may pay as little as $0 for each Doptelet
                    or Doptelet Sprinkle prescription
                  </li>
                  <li>
                    Eligible patients may receive up to a maximum benefit of
                    $15,000 per calendar year
                  </li>
                </ul>
              </>
            }
          />
          <Accordion
            title="Eligibility requirements"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <ul>
                  <li>
                    Have commercial prescription insurance that covers Doptelet
                    or Doptelet Sprinkle
                  </li>
                  <li>
                    The Program is not valid for patients whose prescription
                    claims are reimbursed or paid for, in whole or in part, by
                    any state or federal government program, including, but not
                    limited to Medicaid, Medicare, Medigap, Department of
                    Defense (DoD), Veterans Affairs (VA), TRICARE, Puerto Rico
                    Government Insurance, or any state patient or pharmaceutical
                    assistance program
                  </li>
                  <li>Be 1 year of age or older</li>
                  <li>Be a resident of the United States or Puerto Rico</li>
                </ul>
              </>
            }
          />
          <Accordion
            title="How to enroll"
            id="more-results"
            className="scroll-to-section"
            markup={
              <>
                <ul>
                  <li>
                    Approved pharmacies, healthcare professionals, and Doptelet
                    Connect can enroll patients
                  </li>
                  <li>
                    Patients can enroll themselves or be enrolled by their
                    caregivers
                  </li>
                  <li>
                    Please call <a href="tel:18333682663">1-833-368-2663</a>{" "}
                    Monday–Friday 8:30 AM–7 PM ET for more information
                  </li>
                </ul>
              </>
            }
          />
          <span className="scroll-to-section" ref={termsRef}></span>
          <Accordion
            title="Terms and conditions"
            id="terms"
            className="scroll-to-section"
            markup={
              <>
                <ul>
                  <li>
                    Patients may pay as little as $0 per prescription. Copay
                    Assistance Program has a maximum annual benefit of $15,000
                  </li>
                  <li>
                    The Copay Assistance Program is void where prohibited by
                    law, taxes, or restricted
                  </li>
                  <li>
                    This offer is non-transferable, no substitutions are
                    permissible, and this offer cannot be combined with any
                    other rebate/coupon, free trial, or similar offer for the
                    specified prescription
                  </li>
                  <li>
                    Sobi, Inc. reserves the right to rescind, revoke, or amend
                    this offer at any time without notice
                  </li>
                  <li>
                    For ages 1-6, subject to product availability for Doptelet
                    Sprinkle
                  </li>
                  <li>This offer is not valid for patients paying with cash</li>
                  <li>
                    The Copay Assistance Program for Doptelet or Doptelet
                    Sprinkle is not insurance and is not intended to substitute
                    for insurance
                  </li>
                  <li>
                    Patients, pharmacists, and healthcare providers must not
                    seek reimbursement from health insurance or any third party
                    for any part of the benefit received by the patient through
                    this Copay Assistance Program. Patients must not seek
                    reimbursement from any health savings, flexible spending, or
                    other healthcare reimbursement accounts for the amount of
                    assistance received from the Copay Assistance Program
                  </li>
                  <li>
                    Certain information pertaining to your use of the Copay
                    Assistance Program will be shared with Sobi, Inc., the
                    sponsor of the Copay Assistance Program. The information
                    disclosed will include the date the prescription is filled,
                    the number of pills or product dispensed by the pharmacists,
                    and the amount of your copay that will be paid for by using
                    this Copay Assistance Program. For more information, please
                    see the Sobi Privacy Policy at{" "}
                    <a
                      href="https://sobi-northamerica.com/privacy-policy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      https://sobi-northamerica.com/privacy-policy
                    </a>
                  </li>
                  <li>
                    Acceptance in this Copay Assistance Program is not
                    conditioned on any past, present, or future purchase,
                    including additional doses
                  </li>
                  <li>
                    Enrollment for the Copay Assistance Program is valid through
                    the calendar year
                  </li>
                  <li>
                    Sobi, Inc. reserves the right to change program terms at any
                    time
                  </li>
                  <li>
                    The Program is not valid for claims or transactions
                    submitted more than 90 days from the date the prescription
                    is filled
                  </li>
                  <li>
                    The Program covers the cost of the drug only and does not
                    cover costs for office visits or any other associated costs
                  </li>
                </ul>
              </>
            }
          />
          <h2 style={{ marginTop: "40px" }}>
            See the Free Trial Offer terms and conditions
          </h2>
          <Accordion
            title="Terms and conditions"
            id="more-results"
            className="scroll-to-section mb-0"
            markup={
              <>
                <p>
                  In order to participate in the Doptelet Free Trial Offer, a
                  patient must be new to therapy with Doptelet or Doptelet
                  Sprinkle and be aged ≥1 year for pediatric patients and &gt;18
                  years of age for adults. The patient must be prescribed
                  Doptelet or Doptelet Sprinkle for an approved on-label
                  indication (ITP only) and be under the care of a licensed
                  healthcare provider who is authorized to prescribe medicine in
                  the United States or US Territories, and the patient must
                  reside in the United States or US Territories. Additionally, a
                  patient can only participate in the Doptelet Free Trial Offer
                  once. When prescribed Doptelet Sprinkle under the Free Trial
                  Offer, due to how Doptelet Sprinkle is supplied, eligible
                  patients will receive a bottle with 30 capsules. The offer is
                  void where prohibited by law. Certain rules and restrictions
                  apply. Sobi reserves the right to revoke, rescind, or amend
                  this offer without notice. For ages 1-6, subject to product
                  availability for Doptelet Sprinkle.
                </p>
              </>
            }
          />
        </Section>

        <Section>
          <div className="looking-for-resources">
            <div className="d-flex flex-column flex-lg-row">
              <div className="looking-for-resources-content">
                <h2>
                  Looking for resources to help manage your child’s persistent
                  or chronic ITP?
                </h2>
                <p>
                  Find a getting started brochure, questions to consider before
                  treatment, and more.
                </p>
              </div>
              <div className="looking-for-resources-link">
                <a
                  href="/pediatric-itp/support-and-resources/itp-faqs/"
                  className="btn btn-primary btn-arrow"
                >
                  <span>Patient Resources &amp; FAQS</span>
                </a>
              </div>
            </div>
          </div>
        </Section>
      </PEDLayout>
    </React.Fragment>
  );
}
